import { render, staticRenderFns } from "./CommentTemplate.vue?vue&type=template&id=55b9f338&scoped=true&"
import script from "./CommentTemplate.vue?vue&type=script&lang=js&"
export * from "./CommentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CommentTemplate.vue?vue&type=style&index=0&id=55b9f338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9f338",
  null
  
)

export default component.exports